module.exports = __webpack_public_path__ + "images/letter-open.375c42702967597936a6.svg";